export default __webpack_public_path__ + "static/media/books2-afterA-768w.dfb98274.avif";